import * as React from 'react'

import { useStorage } from './use-storage'

import { type Block } from '@basehub/data/replicache/index'

export const useAntiLayoutShift = <T>({
  blockId,
  storeSuffix,
  initialValue = 0,
}: {
  blockId: Block['id']
  storeSuffix: string
  initialValue?: number | '100%'
}) => {
  const ref = React.useRef<T>(null)
  const [releaseAntiLayoutShiftStyle, setReleaseAntiLayoutShiftStyle] =
    React.useState(false)
  const [lastObservedHeight, setLastObservedHeight] = useStorage(
    'sessionStorage',
    (z) => z.union([z.number(), z.literal('100%')]),
    `block-last-height-${blockId}-${storeSuffix}`,
    { initialValue, dangerouslyCalculateOnHydration: true }
  )

  return {
    ref,
    antiLayoutShiftStyle: {
      height: releaseAntiLayoutShiftStyle ? undefined : lastObservedHeight,
      flexShrink: 0,
    },
    updateHeight: (height: number) => {
      setLastObservedHeight(height)
      setReleaseAntiLayoutShiftStyle(true)
    },
  }
}
